// src/hooks/useAddToCart.ts
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import analytics from "src/helpers/analytics";
import { EVENT_NAMES, SCREEN_NAMES } from "src/helpers/analytics/events";
import { useAppDispatch } from "src/redux/hooks";
import { addLabTestToCartRequest } from "src/redux/slices/labTestSlice";

export const useAddToCart = (onCartUpdate?: () => void) => {
  const dispatch = useAppDispatch();
  const [loadingTestId, setLoadingTestId] = useState<string | null>(null);
  const navigate = useNavigate();
  const params = useParams();
  const supportProgramKey = params["support-program-key"];

  const handleAddToCart = (
    diagnostic_catalog_master_id: string,
    catalog_name: string,
    viewAll?: boolean
  ) => {
    // Event: LAB_TEST_ADD_TO_CART_CLICKED
    analytics.trackEvent(EVENT_NAMES.LAB_TEST_ADD_TO_CART_CLICKED, {
      screen_name: SCREEN_NAMES.BOOK_LAB_TEST_SCREEN,
      support_program_key: supportProgramKey,
      lab_test_name: catalog_name,
      lab_test_id: diagnostic_catalog_master_id,
    });
    setLoadingTestId(diagnostic_catalog_master_id);
    new Promise((resolve, reject) => {
      dispatch(
        addLabTestToCartRequest({
          resolve,
          reject,
          payload: { diagnostic_catalog_master_id },
        })
      );
    })
      .then(() => {
        // Event: LAB_TEST_ADD_TO_CART_SUCCESS
        analytics.trackEvent(EVENT_NAMES.LAB_TEST_ADD_TO_CART_SUCCESS, {
          screen_name: SCREEN_NAMES.BOOK_LAB_TEST_SCREEN,
          support_program_key: supportProgramKey,
          lab_test_name: catalog_name,
          lab_test_id: diagnostic_catalog_master_id,
        });
      })
      .catch((err) => {
        // Event: LAB_TEST_ADD_TO_CART_ERROR
        analytics.trackEvent(EVENT_NAMES.LAB_TEST_ADD_TO_CART_ERROR, {
          screen_name: SCREEN_NAMES.BOOK_LAB_TEST_SCREEN,
          support_program_key: supportProgramKey,
          lab_test_name: catalog_name,
          lab_test_id: diagnostic_catalog_master_id,
        });
      })
      .finally(() => {
        setLoadingTestId(null);
        onCartUpdate?.();
        if (viewAll) {
          navigate(`/app/${supportProgramKey}/book-lab-test`);
        }
      });
  };

  const isTestLoading = (testId: string) => loadingTestId === testId;
  const isAnyTestLoading = loadingTestId !== null;

  return { handleAddToCart, isTestLoading, isAnyTestLoading, loadingTestId };
};
